// Hardcoded shop text - no longer from Directus
export const useShopText = () => {
  return {
    filter_by: 'Filter by',
    shop_all: 'Shop All',
    price_from: 'From',
    back_in_stock_soon: 'Back in stock soon',
    choose_your_plan: 'Choose your plan',
    add_to_basket: 'Add to basket',
    free_uk_delivery: 'Free UK delivery',
    added_to_your_basket: 'Added to your basket',
    keep_shopping: 'Keep shopping',
    view_basket: 'View basket',
    best_seller: 'Best seller',
    selling_fast: 'Selling fast',
    low_in_stock: 'Low in stock',
    digital_product: 'Digital product',
    free_delivery: 'Free delivery',
    pause_or_cancel: 'Pause or cancel anytime',
    delivered_every_30_days: 'Delivered every 30 days',
  };
};
